<template>
    <div
        v-if="consultation !== null"
        class="container-fluid">
        <div class="row">
            <div class="col">
                <div class="mb-3">
                    <consultation-timer
                        user-type="doctor"
                        :consultation="consultation"
                        :doctor="consultation.doctor"
                        :timezone="timezone">
                    </consultation-timer>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12 mb-3">
                {{ `${$locale.consultation_host}` }}時にトラブルが発生した場合は右記リンクからご報告ください: <a href="https://form.run/@yokumiru-trouble-report">https://form.run/@yokumiru-trouble-report</a>    
            </div>            
        </div>

        <div class="row">
            <div class="col-md-12 col-lg-6 mb-3">
                <alert-consultation-timer
                    :consultation="consultation"
                    :timezone="consultation.doctor.timezone">
                </alert-consultation-timer>
                <div
                    v-if="!consultation.started_at && !isClosed && !isDoctorCancelMatching"
                    class="row">
                    <div class="col-md-12 mb-3">
                        <div class="vc-pre d-flex justify-content-center align-items-center">
                            <div>
                                <div class="vc-pre__message-wrapper">
                                    <p class="vc-pre__message">{{ preMessage }}</p>
                                    <p class="vc-pre__message-sub">{{ preMessageSub }}</p>
                                </div>
                                <div class="d-flex justify-content-center align-items-center">
                                    <b-button
                                        v-if="!isPastEndTimeElapsed"
                                        variant="yokumiru-doctor"
                                        class="ml-2 mr-2"
                                        :disabled="!canStart"
                                        @click="showReservationStartModal">
                                        {{ `${$locale.consultation_host}を開始` }}
                                    </b-button>
                                    <b-button
                                        v-if="!isPastEndTimeElapsed && showCancelBtn"
                                        :variant="canCancel ? 'yokumiru-orange' : 'yokumiru-gray'"
                                        class="ml-2 mr-2"
                                        :disabled="!canCancel"
                                        @click="showReservationCancelModal">
                                        {{ `${$locale.consultation_host}をキャンセル` }}
                                    </b-button>
                                </div>
                                <div class="d-flex justify-content-center mt-4">
                                    <a
                                        href="#"
                                        class="linkTest d-block ml-2 mr-2"
                                        @click="showVideoTestModal">
                                        マイクとカメラのテスト
                                    </a>
                                    <a
                                        href="#"
                                        class="linkTest d-block ml-2 mr-2"
                                        @click="showNetworkTestModal">
                                        ネットワーク接続のテスト
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    v-show="agoraInit && isHold"
                    class="row">
                    <div class="col-md-12 mb-3">
                        <doctor-video-stream-agora
                            :room-key="consultation.room_key"
                            :api-key="apiKey"
                            :token="token"
                            :screen-token="screenToken"
                            :transcode="transcode"
                            :debug="debug"
                            :user="consultation.user"
                            :consultation="consultation">
                        </doctor-video-stream-agora>

                        <div class="vc-consultation-close d-flex justify-content-center align-items-center">
                            <b-button
                                variant="yokumiru-doctor"
                                class="ml-2 mr-2"
                                :disabled="!canFinish"
                                @click="showReservationFinishModal">
                                {{ `${$locale.consultation_host}を終了` }}
                            </b-button>
                        </div>
                    </div>
                </div>

                <div
                    v-if="isClosed || isDoctorCancelMatching"
                    class="row">
                    <div class="col-md-12 mb-3">
                        <div class="vc-pre d-flex justify-content-center align-items-center">
                            <div>
                                <div class="vc-pre__message-wrapper">
                                    <p class="vc-pre__message">
                                        {{ $locale.consultation_host }}は{{ consultation.flg_cancel || isDoctorCancelMatching ? 'キャンセルされました' : '終了しました' }}
                                    </p>
                                </div>
                                <div class="d-flex justify-content-center align-items-center">
                                    <b-button
                                        variant="yokumiru-white"
                                        class="ml-2 mr-2 vc-btn-back text-muted"
                                        @click="onCloseBtn">
                                        {{ `${$locale.consultation_host}室を閉じる` }}
                                    </b-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12 mb-3">
                        <b-card
                            no-body
                            class="consultationLeftCard">
                            <b-tabs card>
                                <b-tab>
                                    <template slot="title">{{ $locale.patient }}情報</template>
                                    <b-container>
                                        <div class="d-md-block d-flex justify-content-center">
                                            <user-profile
                                                :user="consultation.user"
                                                :doctor-id="consultation.doctor_id"
                                                userType="doctor">
                                            </user-profile>
                                        </div>
                                    </b-container>
                                </b-tab>
                                <b-tab v-if="isFetchedDoctorMenu && doctorMenu !== null">
                                    <template slot="title">予約メニュー</template>
                                    <b-container>
                                        <div class="doctorMenu">
                                            <doctor-menu-info
                                                :menu="doctorMenu"
                                                :consultation="consultation"
                                                doctor-introduction-type="history">
                                            </doctor-menu-info>
                                        </div>
                                    </b-container>
                                </b-tab>
                            </b-tabs>
                        </b-card>

                        <div
                            v-if="consultation.user !== null"
                            class="btnNewReservationWrapper">
                            <btn-new-reservation :user="consultation.user"/>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-12 col-lg-6 mb-3">
                <div class="row">
                    <div class="col-md-12 mb-3">
                        <b-card no-body>
                            <b-tabs v-model="tabIndex" card>
                                <b-tab @click="onTabClick('interviewt', $event)">
                                    <template slot="title">
                                        <b-icon-file-earmark-text></b-icon-file-earmark-text> {{ $locale.question }}
                                    </template>
                                    <b-container>
                                        <div class="c-box-scroll c-box-scroll--500">
                                            <doctor-interview-answers
                                                :consultation-id="consultation.id"
                                                :is-only-content="1"
                                                :flg-reserved-by-doctor="consultation.flg_reserved_by_doctor">
                                            </doctor-interview-answers>
                                        </div>
                                    </b-container>
                                </b-tab>
                                <b-tab
                                    :title-item-class="tabCSS.chat"
                                    @click="onTabClick('chat', $event)">
                                    <template slot="title">
                                        <b-icon-chat-dots-fill></b-icon-chat-dots-fill> チャット
                                    </template>
                                    <b-container>
                                        <div class="pb-5">
                                            <doctor-chat
                                                :consultation="consultation"
                                                :timezone="timezone"
                                                :is-active="currentTabName === 'chat'"
                                                is-only-content>
                                            </doctor-chat>
                                        </div>
                                    </b-container>
                                </b-tab>
                                <b-tab
                                    @click="onTabClick('medical_record', $event)">
                                    <template slot="title">
                                        <b-icon-clipboard-data></b-icon-clipboard-data> {{ `${$locale.consultation_host}記録` }}
                                    </template>
                                    <b-container>
                                        <medical-record-editor
                                            :consultation="consultation"
                                            :medical-record="medicalRecordData">
                                        </medical-record-editor>
                                    </b-container>
                                </b-tab>
                                <b-tab
                                    :title-item-class="tabCSS.image"
                                    @click="onTabClick('image', $event)">
                                    <template slot="title">
                                        <svg class="b-tab-icon-camera" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 16 16" xml:space="preserve">
                                            <g>
                                                <path d="M8,5.6c-1.7,0-3,1.4-3,3s1.4,3,3,3s3-1.4,3-3S9.7,5.6,8,5.6z"/>
                                                <path d="M14.4,4.4h-2.1l-1-2.5H4.8l-1,2.5H3.5V3.1H2v1.3H1.7C1,4.4,0.5,4.9,0.5,5.6V13c0,0.7,0.6,1.2,1.2,1.2h12.7
                                                c0.7,0,1.2-0.6,1.2-1.2V5.6C15.6,4.9,15,4.4,14.4,4.4z M3,4.4H2.5V3.6H3V4.4z M8,13.2c-2.5,0-4.5-2-4.5-4.5s2-4.5,4.5-4.5
                                                s4.5,2,4.5,4.5S10.5,13.2,8,13.2z M13.5,7.4c-0.6,0-1-0.5-1-1s0.5-1,1-1s1,0.5,1,1S14.1,7.4,13.5,7.4z"/>
                                            </g>
                                        </svg>撮影画像
                                    </template>
                                    <b-container>
                                        <div class="c-box-scroll c-box-scroll--500">
                                            <doctor-consultation-images
                                                :consultation-id="consultation.id"
                                                :is-only-content="true">
                                            </doctor-consultation-images>
                                        </div>
                                    </b-container>
                                </b-tab>
                                <b-tab
                                    :title-item-class="tabCSS.attached_image"
                                    @click="onTabClick('attached_image', $event)">
                                    <template slot="title">
                                        <b-icon-images></b-icon-images> 添付画像
                                    </template>
                                    <b-container>
                                        <div class="c-box-scroll c-box-scroll--500">
                                            <doctor-consultation-attached-images
                                                :consultation-id="consultation.id"
                                                is-only-content
                                                editable>
                                            </doctor-consultation-attached-images>
                                        </div>
                                    </b-container>
                                </b-tab>
                            </b-tabs>
                        </b-card>
                    </div>
                </div>

                <div
                    v-if="doctorMenu && doctorMenu.is_health_package && consultationFeedback !== null"
                    class="row">
                    <div class="col-md-12 mb-3">
                        <b-card no-body>
                            <b-tabs card>
                                <b-tab>
                                    <template slot="title">
                                        法人フィードバック
                                    </template>
                                    <b-container>
                                        <doctor-consultation-feedback-editor
                                            :consultation="consultation"
                                            :consultation-feedback="consultationFeedback">
                                        </doctor-consultation-feedback-editor>
                                    </b-container>
                                </b-tab>
                            </b-tabs>
                        </b-card>
                    </div>
                </div>
            </div>
        </div>

        <image-modal/>
        <delete-file-modal user-type="doctor"/>

        <doctor-reservation-start-modal/>
        <doctor-reservation-cancel-modal/>
        <doctor-reservation-finish-modal/>

        <doctor-reservation-doctor-menu-modal :doctor="consultation.doctor"/>
        <doctor-reservation-date-select-modal :doctor="consultation.doctor"/>
        <doctor-reservation-payment-method-modal :doctor="consultation.doctor" :payment-methods="paymentMethods"/>
        <doctor-reservation-confirm-modal
            :doctor="consultation.doctor"
            :consultation-id="consultation.id"
            mute-completed-alert>
        </doctor-reservation-confirm-modal>

        <template v-if="consultation !== null">
            <video-test-modal
                user-type="doctor"
                :consultation="consultation"
                :room-key="consultation.room_key"
                :api-key="apiKey"
                :token="videoTestToken"
                :transcode="transcode"
                :debug="debug">
            </video-test-modal>

            <network-test-modal
                user-type="doctor"
                :consultation="consultation"
                :room-key="consultation.room_key"
                :api-key="apiKey"
                :uplink-token="uplinkTestToken"
                :downlink-token="downlinkTestToken"
                :transcode="transcode"
                :debug="debug">
            </network-test-modal>
        </template>
    </div>
</template>

<script>
    import YokumiruHelper from '../../YokumiruHelper'
    import constants from '../../constants'
    import moment from 'moment-timezone'
    import Echo from 'laravel-echo'
    import AWS from 'aws-sdk'

    export default {
        name: 'DoctorConsultation',

        props: {
            consultationData: {
                type: Object,
                required: true,
            },
            medicalRecordData: {
                type: Object,
                required: true,
            },
            consultationFeedback: {
                type: Object,
                default: null,
            },
            paymentMethods: {
                type: Array,
                required: true,
            },
            timezone: {
                type: String,
                required: true,
            },
            apiKey: {
                type: String,
                default: '',
            },
            token: {
                type: String,
                default: '',
            },
            screenToken: {
                type: String,
                default: '',
            },
            videoTestToken: {
                type: String,
                default: '',
            },
            uplinkTestToken: {
                type: String,
                default: '',
            },
            downlinkTestToken: {
                type: String,
                default: '',
            },
            transcode: {
                type: String,
                default: 'rtc', // rtc or live
            },
            debug: {
                type: String,
                default: '0',
            },
            logGroupName: {
                type: String,
                required: true,
            },
            poolId: {
                type: String,
                required: true,
            },
        },

        data: function() {
            return {
                helper: YokumiruHelper,
                cwlClient: null,
                isInitCwlClient: false,
                cwlQueues: [],
                consultation: null,
                tabIndex: 0,
                tabCSS: {
                    chat: '',
                    image: '',
                    attached_image: '',
                },
                currentTabName: 'interview',
                canStartTimeElapsed: false,
                isPastEndTimeElapsed: false,
                agoraInit: false,
                doctorMenu: null,
                isFetchedDoctorMenu: false,
                isDoctorCancelMatching: false,
            }
        },

        computed: {
            /**
             * 相談開始可能判定
             *
             * @return {boolean}
             */
            canStart: function () {
                if (!this.consultation || this.consultation.flg_cancel) {
                    return false
                }

                if (!this.consultation.user) {
                    return false
                }

                if (this.$store.state.configs.subscription == 1) {
                    if (!constants.consultations.canStartDoctorAll.includes(this.consultation.status)) {
                        return false
                    }
                } else {
                    if (!constants.consultations.asSkipAuthorization.canStartDoctorAll.includes(this.consultation.status)) {
                        return false
                    }
                }

                return this.canStartTimeElapsed
            },

            /**
             * 相談キャンセル可能判定
             *
             * @return {boolean}
             */
            canCancel: function () {
                if (!this.consultation || this.consultation.flg_cancel) {
                    return false
                }

                const canStatus = constants.consultations.canCancelAll.includes(this.consultation.status)

                if (this.$locale.type === 'consul') {
                    return canStatus
                }
                return canStatus && this.isBeforeLimit
            },

            /**
             * キャンセル受付時間判定
             *
             * @return {boolean}
             */
            isBeforeLimit: function() {
                return this.consultation && moment(this.consultation.start_time).diff(moment.now(), "minutes") > this.$store.state.configs.reservation_cancel_allowable_minute
            },

            /**
             * 相談キャンセルボタンの表示判定
             *
             * @return {boolean}
             */
            showCancelBtn: function () {
                if (!this.consultation) return false

                if (this.consultation.status !== constants.consultations.confirmed) {
                    return true
                }
                return this.$store.state.configs.reservation_cancel_after_confirm_doctor == 1
            },

            /**
             * 相談終了可能判定
             *
             * @return {boolean}
             */
            canFinish: function () {
                if (!this.consultation || this.consultation.flg_cancel) {
                    return false
                }
                return constants.consultations.canFinishAll.includes(this.consultation.status)
            },

            /**
             * 相談中判定
             * @return {boolean}
             */
            isHold: function () {
                return this.consultation && this.consultation.status === constants.consultations.hold
            },

            /**
             * 相談終了／キャンセル済み判定
             * @return {boolean}
             */
            isClosed: function () {
                return this.consultation && constants.consultations.closedAll.includes(this.consultation.status)
            },

            /**
             * 相談開始前メッセージ
             *
             * @return {string}
             */
            preMessage: function () {
                if (this.isPastEndTimeElapsed) {
                    return '入室可能時間を過ぎています'
                } else if (this.canStart) {
                    return `${this.$locale.consultation_host}を開始してください`
                } else {
                    return `予定開始時刻の${this.$store.state.configs.consultation_enter_min_start}分前から${this.$locale.consultation_host}が開始できます`
                }
            },

            /**
             * 相談開始前メッセージサブ
             *
             * @return {string}
             */
            preMessageSub: function () {
                if (this.isPastEndTimeElapsed) {
                    return `お手数かけますが、改めて${this.$locale.consultation_host}予約を行ってください`
                } else if (this.canStart && this.$store.state.configs.consultation_allow_absence_doctor == 1) {
                    return `予定開始時刻を${this.$store.state.configs.consultation_absence_min_doctor}分過ぎると${this.$locale.consultation_host}がキャンセルされます`
                } else {
                    return ''
                }
            },
        },

        created: function() {
            // pusherの同時接続数を抑えるようにする
            // @see https://github.com/sewii/Yokumiru/issues/617
            window.Pusher = require('pusher-js')
            window.Echo = new Echo({
                broadcaster: 'pusher',
                key: process.env.MIX_PUSHER_APP_KEY,
                cluster: process.env.MIX_PUSHER_APP_CLUSTER,
                encrypted: true,
                disableStats: true,
                forceTLS: true,
            })

            this.consultation = this.consultationData
            this.fetchDoctorMenu()

            bus.$on('queue-cloud-watch-logs-doctor', this.queueCwLogs)
            bus.$on('update-tab-css', this.updateTabCSS)
            bus.$on('focus-chat-send-message', this.focusChatMessageTextArea)
            bus.$on('doctor-reservation-started', this.onDoctorReservationStarted)
            bus.$on('doctor-reservation-canceled', this.refreshConsultation)
            bus.$on('doctor-reservation-finished', this.refreshConsultation)
            bus.$on('doctor-reservation-user-absent', this.refreshConsultation)
            bus.$on('can-start-time-elapsed', () => this.canStartTimeElapsed = true)
            bus.$on('is-past-end-time-elapsed', () => this.isPastEndTimeElapsed = true)
            bus.$on('medical-record-validation-failed', this.switchToMedicalRecordTab)
        },

        beforeDestroy: function () {
            bus.$off('queue-cloud-watch-logs-doctor')
            bus.$off('update-tab-css')
            bus.$off('focus-chat-send-message')
            bus.$off('doctor-reservation-started')
            bus.$off('doctor-reservation-canceled')
            bus.$off('doctor-reservation-finished')
            bus.$off('doctor-reservation-user-absent')
            bus.$off('can-start-time-elapsed')
            bus.$off('is-past-end-time-elapsed')
            bus.$off('medical-record-validation-failed')
        },

        mounted: function () {
            window.addEventListener('beforeunload', (event) => {
                if (this.isHold) {
                    event.preventDefault()
                }
            })
            if (!this.agoraInit && this.isHold) {
                this.agoraInit = true
                this.initAwsSdk()
                bus.$emit('doctor-agora-init')
                this.queueCwLogs(`[doctor] userAgent: ${navigator.userAgent}`)
                this.queueCwLogs(`[doctor] pusher channelName: consultation.${this.consultation.id}`)
                this.queueCwLogs('[doctor] re-enter room.')
            }

            /**
             * ブラウザが非アクティブ化されたときにCloudWatchLogsへログ保存する
             */
            document.addEventListener('visibilitychange', () => {
                if (document.visibilityState === 'hidden' && this.consultation !== null) {
                    const queues = this.spliceCwLogs()
                    if (queues.length < 1) return
                    const formData = new FormData()
                    formData.append('timestamps[]', queues[0].timestamp)
                    formData.append('messages[]', '[doctor] send from beacon start.')
                    queues.forEach((q) => {
                        formData.append('timestamps[]', q.timestamp)
                        formData.append('messages[]', q.message)
                    })
                    formData.append('timestamps[]', Date.now())
                    formData.append('messages[]', '[doctor] send from beacon end.')
                    navigator.sendBeacon(`${constants.doctor.consultations.endpoint.base}/${this.consultation.id}/beacon`, formData)
                }
            })

            window.Echo.private(`consultation.${this.consultation.id}`)
                .listen('ConsultationConfirmed', () => {
                    // 相談予約確定時
                    this.fetchConsultation()
                    this.queueCwLogs(`[doctor] pusher event 'ConsultationConfirmed' listened.`)
                })
                .listen('ConsultationUserEntered', () => {
                    // ユーザ入室時
                    this.fetchConsultation()
                    this.queueCwLogs(`[doctor] pusher event 'ConsultationUserEntered' listened.`)
                })
                // .listen('ConsultationStarted', () => {
                //     // 相談開始時（医師が相談開始ボタンを押下）
                //     this.fetchConsultation()
                //     this.queueCwLogs(`[doctor] pusher event 'ConsultationStarted' listened.`)
                // })
                .listen('ConsultationDoctorAbsent', () => {
                    // 未入室終了（医師）
                    this.fetchConsultation()
                    bus.$emit('doctor-agora-should-clear')
                    this.queueCwLogs(`[doctor] pusher event 'ConsultationDoctorAbsent' listened.`)
                })
                .listen('ConsultationUserAbsent', () => {
                    // 未入室終了（ユーザ）
                    this.fetchConsultation()
                    bus.$emit('doctor-agora-should-clear')
                    this.queueCwLogs(`[doctor] pusher event 'ConsultationUserAbsent' listened.`)
                })
                .listen('ConsultationCanceled', () => {
                    // 相談キャンセル時（ユーザによるキャンセル時用）
                    this.fetchConsultation()
                    bus.$emit('doctor-agora-should-clear')
                    this.queueCwLogs(`[doctor] pusher event 'ConsultationCanceled' listened.`)
                })
                .listen('ConsultationFinished', () => {
                    // 相談終了時（入室可能時間の超過時用）
                    this.fetchConsultation()
                    bus.$emit('doctor-agora-should-clear')
                    this.queueCwLogs(`[doctor] pusher event 'ConsultationFinished' listened.`)
                })
        },

        methods: {
            /**
             * aws-sdk 初期化
             * @see https://github.com/sewii/Yokumiru/issues/612
             */
            initAwsSdk: function () {
                if (this.isInitCwlClient) return

                AWS.config.region = 'ap-northeast-1'
                AWS.config.credentials = new AWS.CognitoIdentityCredentials({
                    IdentityPoolId: this.poolId,
                })

                AWS.config.credentials.get((err) => {
                    if (err) return

                    this.cwlClient = new AWS.CloudWatchLogs()
                    this.cwlClient.describeLogStreams({
                        logGroupName: this.logGroupName,
                        logStreamNamePrefix: `${this.consultation.id}_consultation`,
                        limit: 1,
                    }, (err, data) => {
                        // ログストリームが存在しなければ新規作成
                        if (!err && (data.logStreams.length < 1 || data.logStreams[0].logStreamName !== `${this.consultation.id}_consultation`)) {
                            this.cwlClient.createLogStream({
                                logGroupName: this.logGroupName,
                                logStreamName: `${this.consultation.id}_consultation`,
                            }, (err, data) => {
                                if (err) return
                                this.isInitCwlClient = true
                                this.queueCwLogs(`[doctor] log stream '${this.consultation.id}_consultation' created.`)
                                this.queueCwLogs(`[doctor] init aws sdk completed.`)
                                this.poolCwLogs()
                            })
                        }
                        else {
                            this.isInitCwlClient = true
                            this.queueCwLogs(`[doctor] init aws sdk completed.`)
                            this.poolCwLogs()
                        }
                    })
                })
            },

            /**
             * CloudWatchLogs ログ保存処理のプーリング
             */
            poolCwLogs: function () {
                setInterval(() => this.putCwLogs(), 20000)
            },

            /**
             * 蓄積されたログの切り出し
             * @return {*[]}
             */
            spliceCwLogs: function () {
                const queues = [...this.cwlQueues]
                this.cwlQueues = this.cwlQueues.splice(queues.length)
                return queues
            },

            /**
             * CloudWatch Logs ログ保存処理
             */
            putCwLogs: function () {
                if (!this.isInitCwlClient || this.cwlQueues.length < 1) return

                const queues = this.spliceCwLogs()
                if (queues.length < 1) return

                return this.cwlClient.putLogEvents({
                    logGroupName: this.logGroupName,
                    logStreamName: `${this.consultation.id}_consultation`,
                    logEvents: queues,
                }, (err, data) => { /* callback未定義だと動作しないケースがあるため消さないこと */ })
            },

            /**
             * CloudWatch Logs キュー追加
             * @param {string} message
             */
            queueCwLogs: function (message) {
                this.cwlQueues.push({
                    timestamp: Date.now(),
                    message: message,
                })
            },

            /**
             * 医師メニュー詳細取得
             */
            fetchDoctorMenu: async function () {
                this.doctorMenu = null
                if (this.consultation.doctor_menu_id) {
                    await axios.get(`${constants.doctor.doctor_menus.endpoint.base}/${this.consultation.doctor_menu_id}`)
                        .then(({data}) => {
                            this.doctorMenu = data.data
                        })
                }
                this.isFetchedDoctorMenu = true
            },

            updateTabCSS: function (tabName, exists) {
                this.tabCSS[tabName] = exists ? 'b-tab-content-exists-doctor' : ''
            },

            onTabClick: function (tabName, e) {
                if (e && e.target && e.target.closest('a.nav-link')) {
                    this.currentTabName = tabName

                    if (tabName === 'chat') {
                        this.$nextTick(() => {
                            this.focusChatMessageTextArea()
                            bus.$emit('chat-scroll')
                        })
                        this.readMessages()
                    }
                    else if (tabName === 'medical_record') {
                        this.$nextTick(() => this.focusMedicalRecordTextArea())
                    }
                }
            },

            /**
             * チャットメッセージ既読化
             */
            readMessages: function () {
                axios.put(`${constants.doctor.consultations.endpoint.base}/${this.consultation.id}/message_read`)
            },

            focusChatMessageTextArea: function () {
                document.getElementById('chat_message_textarea').focus()
            },

            focusMedicalRecordTextArea: function () {
                document.getElementById('medical_record_edit').focus()
            },

            /**
             * 相談開始時
             *
             * @param {object} consultation
             */
            onDoctorReservationStarted: function (consultation) {
                this.agoraInit = true
                this.initAwsSdk()
                this.consultation = consultation
                bus.$emit('doctor-agora-init')
                this.queueCwLogs(`[doctor] userAgent: ${navigator.userAgent}`)
                this.queueCwLogs(`[doctor] pusher channelName: consultation.${this.consultation.id}`)
                this.queueCwLogs('[doctor] enter room.')
            },

            /**
             * 診療予約の取得
             */
            fetchConsultation: function () {
                if ( ! this.isDoctorCancelMatching) {
                    axios.get(`${constants.doctor.consultations.endpoint.base}/${this.consultation.id}`)
                    .then(({data}) => {
                        this.refreshConsultation(data)
                    })
                }
            },

            /**
             * APIリクエスト後の相談予約データでリフレッシュ
             *
             * @param {object} consultation
             */
            refreshConsultation: function (consultation) {
                if (!consultation.doctor_id) {
                    this.isDoctorCancelMatching = true
                    return;
                }

                this.consultation = consultation;
            },

            /**
             * 相談記録タブにスイッチ
             */
            switchToMedicalRecordTab: function () {
                this.tabIndex = 2
            },

            /**
             * 開始モーダル表示
             */
            showReservationStartModal: function () {
                bus.$emit('open-modal-doctor-reservation-start', this.consultation)
            },

            /**
             * キャンセルモーダル表示
             */
            showReservationCancelModal: function () {
                bus.$emit('open-modal-doctor-reservation-cancel', this.consultation)
            },

            /**
             * 終了モーダル表示
             */
            showReservationFinishModal: function () {
                bus.$emit('open-modal-doctor-reservation-finish', this.consultation)
            },

            /**
             * マイクとカメラのテストモーダル表示
             */
            showVideoTestModal: function () {
                if (this.inProgress) return
                this.initAwsSdk()
                this.queueCwLogs(`[doctor] userAgent: ${navigator.userAgent}`)
                this.queueCwLogs('[doctor] show video test modal.')
                bus.$emit('open-modal-video-test')
            },

            /**
             * ネットワーク接続のテストモーダル表示
             */
            showNetworkTestModal: function () {
                if (this.inProgress) return
                this.initAwsSdk()
                this.queueCwLogs(`[doctor] userAgent: ${navigator.userAgent}`)
                this.queueCwLogs('[doctor] show network test modal.')
                bus.$emit('open-modal-network-test')
            },

            onCloseBtn: function () {
                window.close()
            }
        }
    }
</script>

<style lang="scss" scoped>
.consultationLeftCard {
    position: relative;
}

.btnNewReservationWrapper {
    position: absolute;
    z-index: 2;
    right: 30px;
    top: 13px;
}

.doctorMenu {
    position: relative;
    display: inline-block;
    vertical-align: top;
    width: 100%;
    max-width: 720px;
    margin: 15px;
    padding: 25px;
    background-color: #f9f9f9;
    border: 1px solid #dee2e6;
    border-radius: 6px;
}

.vc-pre {
    min-height: 350px;
    padding: 30px;
    background: #808080;
    border: 1px solid #808080;
    border-radius: 4px;
    box-sizing: border-box;

    .vc-pre__message-wrapper {
        margin-bottom: 15px;
    }

    .vc-pre__message {
        margin-bottom: 5px;
        color: #fff;
        font-size: 1rem;
        font-weight: bold;
        text-align: center;
    }

    .vc-pre__message-sub {
        color: #fff;
        font-size: 0.8rem;
        font-weight: normal;
        text-align: center;
    }

    button, .vc-btn-back {
        box-shadow: 0 2px 5px rgba(0,0,0,0.125);
    }
}

.vc-consultation-close {
    padding: 10px;
    background: #fff;
    border-radius: 0 0 4px 4px;
}

.linkTest {
    color: #fff;
    text-decoration: underline;

    &:hover {
        text-decoration: none;
    }
}
</style>
